import { setToken } from 'features/auth/tokensSlice';
import useQuery from 'hooks/useQueryTokenFromUrl';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';

import BackdropLoading from 'components/BackdropLoading';

const TokenInitializer = ({ children }: { children: React.ReactNode }) => {
  const queryToken = useQuery();
  const dispatch = useDispatch();
  const tokenInStore = useSelector(
    (state: RootState) => state.token.accessToken,
  );
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initToken = async () => {
      if (queryToken) {
        dispatch(setToken(queryToken));

        // Remove o token da URL após processar
        const url = new URL(window.location.href);
        url.searchParams.delete('token');
        window.history.replaceState({}, '', url.pathname);
      }

      setInitialized(true);
    };

    initToken();
  }, [queryToken, dispatch]);

  // Aguarda processamento do token
  if (!initialized && !tokenInStore) {
    return <BackdropLoading />;
  }

  return <>{children}</>;
};

export default TokenInitializer;
